import { Center, NumberInput } from '@mantine/core'
import { ShipmentType } from 'types/orders'
import { MantineTableCellProps, useEdit } from './useEdit'

export default function EditNumberInput(
  props: MantineTableCellProps<ShipmentType> & { error: string | undefined; onFocus: () => void }
) {
  const { value, handleOnChange, handleBlur } = useEdit<ShipmentType>(props)
  return (
    <Center>
      <NumberInput
        hideControls
        decimalSeparator=","
        decimalScale={2}
        placeholder="Koszt przesyłki"
        error={props.error}
        onFocus={props.onFocus}
        value={value as number}
        onChange={(value) => handleOnChange(value)}
        onBlur={handleBlur}
      />
    </Center>
  )
}
